// This file was auto-generated by Fern from our API Definition.
export class AgentaApiTimeoutError extends Error {
    cause;
    constructor(message, opts) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
        this.name = this.constructor.name;
        if (opts?.cause != null) {
            this.cause = opts.cause;
        }
    }
}
